import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@components';

import { IconPerson } from '@icons';

import { IAppInstallsProps } from './types';

import * as s from './AppInstalls.scss';

export const AppInstalls: React.FC<IAppInstallsProps> = (props: IAppInstallsProps) => {
	const {
		className,
		installs,
	} = props;

	return installs != null
		? (
			<div className={classNames(s.block, className)}>
				<Icon
					className={s.icon}
					glyph={IconPerson}
				/>
				<span className={s.text}>{installs}</span>
			</div>
		)
		: null;
};
